/**
 * Created by litao on 2018/10/8.
 */
import JBoot from 'jboot-env';
import 'jboot-env/style/number-font/index.css';
// import JBoot from '../../jboot-env/index';

import Vue from 'vue';
import VueQuillEditor  from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import './style/index.scss';
import '../static/ueditor/ueditor.parse.min'
import '../static/ueditor/lang/zh-cn/zh-cn'
import configure from './configure/index';
import axios from 'axios';

axios.defaults.withCredentials = true;

Vue.prototype.$axios = axios;
Vue.use(VueQuillEditor);



let T = new JBoot(Vue, configure);
T.$vue.prototype.$formatMoney = formatMoney;
let text = '这是测试通知，Demo在main.js文件中';
function formatMoney(val) {
    val=val/100;
    val = val.toString().replace(/\$|\,/g,'');
    if(isNaN(val)) {
        val = "0";
    }
    let sign = (val == (val = Math.abs(val)));
    val = Math.floor(val*100+0.50000000001);
    let cents = val%100;
    val = Math.floor(val/100).toString();
    if(cents<10) {
        cents = "0" + cents
    }
    for (var i = 0; i < Math.floor((val.length-(1+i))/3); i++) {
        val = val.substring(0,val.length-(4*i+3))+',' + val.substring(val.length-(4*i+3));
    }

    return (((sign)?'':'-') + val + '.' + cents);
}

Vue.filter('money', function(val) {
    val=val/100;
    val = val.toString().replace(/\$|\,/g,'');
    if(isNaN(val)) {
        val = "0";
    }
    let sign = (val == (val = Math.abs(val)));
    val = Math.floor(val*100+0.50000000001);
    let cents = val%100;
    val = Math.floor(val/100).toString();
    if(cents<10) {
        cents = "0" + cents
    }
    for (var i = 0; i < Math.floor((val.length-(1+i))/3); i++) {
        val = val.substring(0,val.length-(4*i+3))+',' + val.substring(val.length-(4*i+3));
    }

    return (((sign)?'':'-') + val + '.' + cents);
});


T.$vue.prototype.$formatExportJson=function(filterVal, jsonData) {
    return jsonData.map(v => filterVal.map(j => {

        let keys = (j.split('.') || []).filter(item => item),
            obj = Object.assign({}, v);

        for (let i = 0; i < keys.length; i++) {
            obj = (obj || {})[keys[i]];
        }
        return obj;
    }))
};


T.$vue.prototype.$getExportParam = function (object) {
    if (!object) {
        return;
    }
    if (typeof object !== 'object') {
        throw new Error("参数错误！");
    }
    let str = "";
    for (let key in object) {
        if (object[key]) {
            let index = key.indexOf(":");
            if (index > -1) {
                let sum = () => {
                    let count = 0;
                    for (let str of key) {
                        if (str === ':') {
                            count++;
                        }
                    }
                    switch (count) {
                        case 1:
                            if (key.includes('GT') || key.includes('LT')) {
                                str += key.split(":")[0] + key.split(":")[1].toLocaleLowerCase() + '=' + object[key] + '&';
                            }else{
                                str += key.split(":")[0] + '=' + object[key] + '&';
                            }
                            break;
                        case 2:
                            str += key.split(":")[0] + key.split(":")[1].toLocaleLowerCase() + '=' + object[key] + '&';
                            break;
                        case 3:
                            str += key.split(":")[1] + key.split(":")[2].toLocaleLowerCase() + '=' + object[key] + '&';
                            break
                        default:
                            throw new Error("冒号异常！");
                    }
                }
                sum();
            } else {
                str += key + '=' + object[key] + '&';
            }
        }
    }
    console.log("2222",str);
    return str.substring(0, str.length - 1);

}



// WEBPACK FOOTER //
// ./src/main.js